import { render, staticRenderFns } from "./MtipoimplicadoForm.vue?vue&type=template&id=1a5feb69"
import script from "./MtipoimplicadoForm.vue?vue&type=script&lang=js"
export * from "./MtipoimplicadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports